import { LinkStatus, UserPosition, UserRole } from '~/types/models';

export const formatUrl = (url?: string) => {
  if (url) {
    return url.startsWith('http') ? url : `http://${url}`;
  }

  return undefined;
};

export const formatUserRole = (userRole: UserRole) => {
  if (userRole === 'admin') {
    return 'Admin';
  }

  if (userRole === 'super_admin') {
    return 'Super Admin';
  }

  if (userRole === 'user') {
    return 'User';
  }

  return '';
};

export const formatUserPosition = (userPosition: UserPosition) => {
  if (userPosition === 'analyst') {
    return 'Analyst';
  }

  if (userPosition === 'devops') {
    return 'Devops';
  }

  if (userPosition === 'developer') {
    return 'Developer';
  }

  return '';
};

export const formatLinkStatus = (linkStatus: LinkStatus) => {
  if (linkStatus === 'activated') {
    return 'Activated';
  }

  if (linkStatus === 'deactivated') {
    return 'Deactivated';
  }

  if (linkStatus === 'expired') {
    return 'Expired';
  }

  if (linkStatus === 'submitted') {
    return 'Submitted';
  }

  return '';
};
